import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const jump = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md border-b border-background-200/80"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="flex h-16 md:h-[72px] items-center justify-between gap-4">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            className="flex items-center gap-2 shrink-0 cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg">
              <i className="ri-play-fill" />
            </span>
            <span className="font-num text-lg md:text-xl font-extrabold tracking-tight text-foreground-950">
              51<span className="text-primary-600">视频</span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1 lg:gap-2" aria-label="主导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  jump(link.id);
                }}
                className="px-3 py-2 text-sm text-foreground-700 rounded-md transition-colors hover:text-primary-700 hover:bg-primary-50 cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => jump("ranking")}
              className="hidden sm:inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-fire-line" />
              看热门主播
            </button>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open ? (
        <div className="md:hidden border-t border-background-200/80 bg-background-50/95 backdrop-blur-md">
          <nav className="mx-auto max-w-page px-4 py-3 grid grid-cols-2 gap-2" aria-label="移动端导航">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  jump(link.id);
                }}
                className="px-3 py-2.5 text-sm text-foreground-700 rounded-md bg-background-100 transition-colors hover:text-primary-700 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}